// Predefined medical questions for each illness type
// No backend or AI needed - works entirely in the browser

export const questionTemplates = {
  "Abdominal Pain": [
    {
      question: "Where exactly is the pain located? (Upper abdomen, lower abdomen, right side, left side, or all over)",
      type: "text"
    },
    {
      question: "How long have you had this pain? (Hours, days, weeks, or months)",
      type: "text"
    },
    {
      question: "On a scale of 1-10, how severe is the pain? (1 being mild, 10 being worst pain ever)",
      type: "text"
    },
    {
      question: "Is the pain constant or does it come and go?",
      type: "text"
    },
    {
      question: "Does anything make the pain better or worse? (Eating, lying down, movement, etc.)",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Nausea, vomiting, fever, diarrhea, constipation)",
      type: "text"
    },
    {
      question: "Have you noticed any changes in your bowel movements?",
      type: "text"
    },
    {
      question: "Have you had any recent changes in diet or medications?",
      type: "text"
    },
    {
      question: "Do you have any medical conditions or previous surgeries?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Nausea and Vomiting": [
    {
      question: "How long have you been experiencing nausea or vomiting?",
      type: "text"
    },
    {
      question: "How often are you vomiting? (Once, multiple times per day, etc.)",
      type: "text"
    },
    {
      question: "What does the vomit look like? (Clear, food, bile, blood)",
      type: "text"
    },
    {
      question: "Do you have any abdominal pain?",
      type: "text"
    },
    {
      question: "Do you have fever or chills?",
      type: "text"
    },
    {
      question: "Are you able to keep down any food or liquids?",
      type: "text"
    },
    {
      question: "Have you had any recent changes in diet or medications?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Diarrhea, headache, dizziness)",
      type: "text"
    },
    {
      question: "Do you have any medical conditions?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Diarrhea": [
    {
      question: "How long have you had diarrhea?",
      type: "text"
    },
    {
      question: "How many bowel movements per day?",
      type: "text"
    },
    {
      question: "Is there any blood in the stool?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain or cramping?",
      type: "text"
    },
    {
      question: "Do you have fever?",
      type: "text"
    },
    {
      question: "Have you traveled recently?",
      type: "text"
    },
    {
      question: "Have you eaten anything unusual?",
      type: "text"
    },
    {
      question: "Are you experiencing dehydration symptoms? (Dry mouth, dizziness, dark urine)",
      type: "text"
    },
    {
      question: "Do you have any medical conditions?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Constipation": [
    {
      question: "How long have you been constipated?",
      type: "text"
    },
    {
      question: "When was your last bowel movement?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain or bloating?",
      type: "text"
    },
    {
      question: "Have you noticed any blood when trying to have a bowel movement?",
      type: "text"
    },
    {
      question: "What is your typical diet like? (Fiber intake, water consumption)",
      type: "text"
    },
    {
      question: "Do you take any medications that might cause constipation?",
      type: "text"
    },
    {
      question: "Have you had any recent changes in activity level?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Nausea, vomiting, weight loss)",
      type: "text"
    },
    {
      question: "Do you have any medical conditions?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Acid Reflux": [
    {
      question: "How long have you been experiencing acid reflux symptoms?",
      type: "text"
    },
    {
      question: "How often do symptoms occur? (Daily, weekly, occasionally)",
      type: "text"
    },
    {
      question: "When do symptoms typically occur? (After meals, at night, when lying down)",
      type: "text"
    },
    {
      question: "On a scale of 1-10, how severe are the symptoms?",
      type: "text"
    },
    {
      question: "Do you have difficulty swallowing?",
      type: "text"
    },
    {
      question: "Do you experience regurgitation of food or sour liquid?",
      type: "text"
    },
    {
      question: "What foods or activities trigger your symptoms?",
      type: "text"
    },
    {
      question: "Have you tried any over-the-counter medications? Did they help?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Chest pain, chronic cough, hoarseness)",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "IBS": [
    {
      question: "How long have you been experiencing IBS symptoms?",
      type: "text"
    },
    {
      question: "What are your main symptoms? (Diarrhea, constipation, or alternating between both)",
      type: "text"
    },
    {
      question: "How often do you have abdominal pain or cramping?",
      type: "text"
    },
    {
      question: "Does your abdominal pain improve after a bowel movement?",
      type: "text"
    },
    {
      question: "Do you experience urgency to have a bowel movement?",
      type: "text"
    },
    {
      question: "What triggers your symptoms? (Stress, certain foods, hormonal changes)",
      type: "text"
    },
    {
      question: "Have you noticed any mucus in your stool?",
      type: "text"
    },
    {
      question: "Have you tried any treatments or dietary changes?",
      type: "text"
    },
    {
      question: "How much does IBS affect your daily life and activities?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Rectal Bleeding": [
    {
      question: "When did you first notice rectal bleeding?",
      type: "text"
    },
    {
      question: "What color is the blood? (Bright red, dark red, maroon, or black/tarry stools)",
      type: "text"
    },
    {
      question: "Where does the blood appear? (On toilet paper, in the bowl, or mixed with stool)",
      type: "text"
    },
    {
      question: "How much blood have you noticed? (Small amount, moderate, large)",
      type: "text"
    },
    {
      question: "Do you have any pain during bowel movements?",
      type: "text"
    },
    {
      question: "Do you have known hemorrhoids or anal fissures?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain or cramping?",
      type: "text"
    },
    {
      question: "Have you noticed any changes in your bowel habits or stool shape?",
      type: "text"
    },
    {
      question: "Do you have a family history of colon cancer or inflammatory bowel disease?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Change in Bowel Habits": [
    {
      question: "What changes have you noticed? (Frequency, stool consistency, color, or shape)",
      type: "text"
    },
    {
      question: "How long has this change been occurring?",
      type: "text"
    },
    {
      question: "Are you experiencing diarrhea, constipation, or alternating between both?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain or cramping?",
      type: "text"
    },
    {
      question: "Have you noticed any blood in your stool?",
      type: "text"
    },
    {
      question: "Have you had any unintentional weight loss?",
      type: "text"
    },
    {
      question: "Have you had any changes in diet or new medications?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Fatigue, fever, loss of appetite)",
      type: "text"
    },
    {
      question: "Do you have a family history of colon cancer or inflammatory bowel disease?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Difficulty Swallowing": [
    {
      question: "How long have you had difficulty swallowing?",
      type: "text"
    },
    {
      question: "Do you have trouble swallowing solids, liquids, or both?",
      type: "text"
    },
    {
      question: "Do you feel like food gets stuck? Where (throat, chest, stomach area)?",
      type: "text"
    },
    {
      question: "Do you have pain when swallowing?",
      type: "text"
    },
    {
      question: "Do you have heartburn or acid reflux?",
      type: "text"
    },
    {
      question: "Have you noticed any weight loss?",
      type: "text"
    },
    {
      question: "Do you have a cough or hoarseness?",
      type: "text"
    },
    {
      question: "Do you regurgitate food?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Chest pain, vomiting)",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Screening Colon": [
    {
      question: "How old are you, and when was your last colonoscopy (if any)?",
      type: "text"
    },
    {
      question: "Do you have a family history of colon cancer, polyps, or inflammatory bowel disease?",
      type: "text"
    },
    {
      question: "Have you had any colon polyps found in previous colonoscopies?",
      type: "text"
    },
    {
      question: "Have you noticed any blood in your stool or changes in bowel habits?",
      type: "text"
    },
    {
      question: "Have you had any unexplained weight loss or fatigue?",
      type: "text"
    },
    {
      question: "Do you have a personal history of inflammatory bowel disease (Crohn's or Ulcerative Colitis)?",
      type: "text"
    },
    {
      question: "Are you currently taking blood thinners or other medications?",
      type: "text"
    },
    {
      question: "Do you have any allergies to medications or anesthesia?",
      type: "text"
    },
    {
      question: "Do you have any medical conditions such as diabetes, heart disease, or kidney disease?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Fatty Liver": [
    {
      question: "How was your fatty liver diagnosed? (Ultrasound, CT scan, blood tests, or liver biopsy)",
      type: "text"
    },
    {
      question: "Do you drink alcohol? If yes, how much per week?",
      type: "text"
    },
    {
      question: "Have you been told your liver enzymes (ALT, AST) are elevated?",
      type: "text"
    },
    {
      question: "Do you have diabetes, pre-diabetes, or high blood sugar?",
      type: "text"
    },
    {
      question: "Do you have high cholesterol or high triglycerides?",
      type: "text"
    },
    {
      question: "Do you have any symptoms? (Fatigue, right upper abdominal discomfort, yellowing of skin/eyes)",
      type: "text"
    },
    {
      question: "What is your approximate weight and height?",
      type: "text"
    },
    {
      question: "Are you taking any medications or supplements?",
      type: "text"
    },
    {
      question: "Do you have any family history of liver disease?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Upper Endoscopy": [
    {
      question: "What symptoms are you experiencing that led to recommending an upper endoscopy?",
      type: "text"
    },
    {
      question: "Do you have persistent heartburn or acid reflux?",
      type: "text"
    },
    {
      question: "Do you have difficulty swallowing?",
      type: "text"
    },
    {
      question: "Have you had any blood in your vomit or black/tarry stools?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain, particularly in the upper area?",
      type: "text"
    },
    {
      question: "Have you had an upper endoscopy before? If so, what were the results?",
      type: "text"
    },
    {
      question: "Are you currently taking blood thinners, aspirin, or anti-inflammatory medications?",
      type: "text"
    },
    {
      question: "Do you have any allergies to medications or anesthesia?",
      type: "text"
    },
    {
      question: "Do you have any medical conditions such as heart disease, diabetes, or kidney disease?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Crohn's Disease": [
    {
      question: "How long have you been experiencing Crohn's disease symptoms?",
      type: "text"
    },
    {
      question: "Where is your Crohn's disease located? (Small intestine, large intestine, or both)",
      type: "text"
    },
    {
      question: "Are you currently having a flare-up? What are your main symptoms?",
      type: "text"
    },
    {
      question: "How many bowel movements do you have per day, and is there blood or mucus?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain or cramping? Where and how severe (1-10)?",
      type: "text"
    },
    {
      question: "Are you currently on any medications for Crohn's? (Steroids, biologics, immunosuppressants)",
      type: "text"
    },
    {
      question: "Have you had any surgeries related to Crohn's disease?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Joint pain, skin rashes, eye inflammation, fatigue)",
      type: "text"
    },
    {
      question: "Have you had any recent weight loss or nutritional issues?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Ulcerative Colitis": [
    {
      question: "How long have you been diagnosed with Ulcerative Colitis?",
      type: "text"
    },
    {
      question: "How much of your colon is affected? (Entire colon, left side, or only the rectum)",
      type: "text"
    },
    {
      question: "Are you currently having a flare-up? What are your main symptoms?",
      type: "text"
    },
    {
      question: "How many bowel movements do you have per day? Is there blood or mucus?",
      type: "text"
    },
    {
      question: "Do you have urgency or inability to control bowel movements?",
      type: "text"
    },
    {
      question: "Are you currently on any medications for UC? (Mesalamine, steroids, biologics)",
      type: "text"
    },
    {
      question: "Have you had any hospitalizations for Ulcerative Colitis?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Joint pain, skin issues, eye problems, fatigue)",
      type: "text"
    },
    {
      question: "Have you had any recent weight loss or changes in appetite?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Anemia": [
    {
      question: "How long have you been experiencing symptoms of anemia?",
      type: "text"
    },
    {
      question: "What symptoms are you experiencing? (Fatigue, weakness, dizziness, shortness of breath, pale skin)",
      type: "text"
    },
    {
      question: "Have you had any blood in your stool, or dark/tarry/black stools?",
      type: "text"
    },
    {
      question: "Have you had blood tests showing low hemoglobin or low iron levels?",
      type: "text"
    },
    {
      question: "Do you have heavy menstrual periods (if female)?",
      type: "text"
    },
    {
      question: "What is your diet like? Do you eat red meat, leafy greens, or iron-rich foods?",
      type: "text"
    },
    {
      question: "Do you have any chronic diseases? (Kidney disease, inflammatory bowel disease, cancer)",
      type: "text"
    },
    {
      question: "Are you taking any medications, including blood thinners or aspirin?",
      type: "text"
    },
    {
      question: "Do you have a family history of blood disorders or anemia?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Jaundice": [
    {
      question: "When did you first notice yellowing of your skin or eyes?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain? Where is it located and how severe (1-10)?",
      type: "text"
    },
    {
      question: "Have you had any fever or chills?",
      type: "text"
    },
    {
      question: "Have you noticed dark urine (tea or cola colored) or light/pale stools?",
      type: "text"
    },
    {
      question: "Do you have nausea, vomiting, or loss of appetite?",
      type: "text"
    },
    {
      question: "Do you drink alcohol? If yes, how much?",
      type: "text"
    },
    {
      question: "Have you been exposed to anyone with hepatitis, or traveled recently?",
      type: "text"
    },
    {
      question: "Are you taking any medications, supplements, or herbal remedies?",
      type: "text"
    },
    {
      question: "Do you have any known liver, gallbladder, or pancreas conditions?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Heartburn/GERD": [
    {
      question: "How long have you been experiencing heartburn?",
      type: "text"
    },
    {
      question: "How often does it occur? (Daily, weekly, occasionally)",
      type: "text"
    },
    {
      question: "When does it typically occur? (After meals, at night, when lying down)",
      type: "text"
    },
    {
      question: "On a scale of 1-10, how severe is the heartburn?",
      type: "text"
    },
    {
      question: "Do you have difficulty swallowing?",
      type: "text"
    },
    {
      question: "Do you experience regurgitation of food or sour liquid?",
      type: "text"
    },
    {
      question: "What foods or activities trigger your symptoms?",
      type: "text"
    },
    {
      question: "Have you tried any over-the-counter medications? Did they help?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Chest pain, cough, hoarseness)",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Bloating": [
    {
      question: "How long have you been experiencing bloating?",
      type: "text"
    },
    {
      question: "When does the bloating typically occur? (After meals, all day, etc.)",
      type: "text"
    },
    {
      question: "Do you have abdominal pain along with bloating?",
      type: "text"
    },
    {
      question: "Do you have changes in bowel movements? (Diarrhea, constipation)",
      type: "text"
    },
    {
      question: "Do you have excessive gas?",
      type: "text"
    },
    {
      question: "What foods seem to trigger the bloating?",
      type: "text"
    },
    {
      question: "Do you have any food intolerances that you know of?",
      type: "text"
    },
    {
      question: "Have you noticed any weight changes?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Nausea, heartburn, fatigue)",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Blood in Stool": [
    {
      question: "When did you first notice blood in your stool?",
      type: "text"
    },
    {
      question: "What color is the blood? (Bright red, dark/black, maroon)",
      type: "text"
    },
    {
      question: "How much blood have you noticed? (Small amount, moderate, large)",
      type: "text"
    },
    {
      question: "Do you have abdominal pain?",
      type: "text"
    },
    {
      question: "Do you have diarrhea or constipation?",
      type: "text"
    },
    {
      question: "Have you had any recent weight loss?",
      type: "text"
    },
    {
      question: "Do you have a family history of colon cancer or inflammatory bowel disease?",
      type: "text"
    },
    {
      question: "Do you have hemorrhoids or anal fissures?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Fatigue, dizziness, weakness)",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Weight Loss": [
    {
      question: "How much weight have you lost and over what period?",
      type: "text"
    },
    {
      question: "Was the weight loss intentional or unintentional?",
      type: "text"
    },
    {
      question: "Have you had any changes in appetite?",
      type: "text"
    },
    {
      question: "Do you have difficulty swallowing?",
      type: "text"
    },
    {
      question: "Do you have abdominal pain?",
      type: "text"
    },
    {
      question: "Do you have changes in bowel movements?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms? (Fatigue, fever, night sweats)",
      type: "text"
    },
    {
      question: "Have you noticed any changes in your energy level?",
      type: "text"
    },
    {
      question: "Do you have any medical conditions or take any medications?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ],

  "Other Problem": [
    {
      question: "Please describe your main symptom or concern",
      type: "text"
    },
    {
      question: "How long have you been experiencing this?",
      type: "text"
    },
    {
      question: "On a scale of 1-10, how severe is it?",
      type: "text"
    },
    {
      question: "Does anything make it better or worse?",
      type: "text"
    },
    {
      question: "Do you have any other symptoms?",
      type: "text"
    },
    {
      question: "Have you had this problem before?",
      type: "text"
    },
    {
      question: "Are you taking any medications?",
      type: "text"
    },
    {
      question: "Do you have any medical conditions?",
      type: "text"
    },
    {
      question: "Have you seen a doctor about this?",
      type: "text"
    },
    {
      question: "Do you need emergency care? (YES/NO)",
      type: "text"
    }
  ]
};

// Generate summary from conversation
export const generateChatbotSummary = (illness, conversation) => {
  let summary = `Patient Presenting Symptom: ${illness}\n\n`;
  summary += `Consultation Date: ${new Date().toLocaleDateString()}\n\n`;
  summary += `Patient Responses:\n\n`;

  if (conversation && conversation.length > 0) {
    conversation.forEach((qa, index) => {
      summary += `Q${index + 1}: ${qa.question}\n`;
      summary += `A${index + 1}: ${qa.answer}\n\n`;
    });
  }

  // Check for emergency
  const emergencyResponse = conversation?.find((qa) =>
    qa.question.toLowerCase().includes("emergency") &&
    qa.answer.toLowerCase().includes("yes")
  );

  if (emergencyResponse) {
    summary += `\n⚠️ URGENT: Patient indicated need for emergency care.\n`;
  }

  return summary;
};

const EMERGENCY_QUESTION = { question: "Do you need emergency care? (YES/NO)", type: "text" };

const getOrderedQuestions = (illness) => {
  const illnessQuestions = questionTemplates[illness] || questionTemplates["Other Problem"];
  const others = illnessQuestions.filter(q => !q.question.toLowerCase().includes('do you need emergency care'));
  return [EMERGENCY_QUESTION, ...others];
};

// Get next question for an illness
export const getNextQuestion = (illness, currentIndex) => {
  const questions = getOrderedQuestions(illness);
  if (currentIndex >= questions.length) return null;
  return { ...questions[currentIndex] }; // Return a fresh copy so mutations never affect the template
};

// Check if chat is complete
export const isChatComplete = (illness, currentIndex) => {
  return currentIndex >= getOrderedQuestions(illness).length;
};
